import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHDONDATHANG } from "../actions/DanhSachDonDatHang/actionTypes";
import {
  getListDanhSachDonDatHangSuccess,
  getListDanhSachDonDatHangFailure,
} from "../actions/DanhSachDonDatHang";
import DatHangApi from "../service/DatHang/DatHangApi";

function* getListDanhSachDonDatHang(action) {
  try {
    sessionStorage.setItem("BanGhiDanhSachDonDatHang", action.dataSearch.iPageSize ?? 20);
    const response = yield call(DatHangApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachDonDatHangSuccess(response.data));
    } else {
      yield put(getListDanhSachDonDatHangFailure());
    }
  } catch (error) {
    yield put(getListDanhSachDonDatHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHDONDATHANG, getListDanhSachDonDatHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
